import template from 'text!./templates/file-upload-viewer.html';
import DocumentUtil from 'edge/gateway/util/DocumentUtil';

var uploadInProgress = false; // Only one file upload dialog at a time

export default [function () {
    return {
        'scope': {
            'uploadConfig': '=',
            'documents': '=',
            'dropZoneSelector': '&',
            'hideDropArea': '&',
            'removeFunction': '&'
        },
        'template': template,
        'controller': ['$window', '$scope', '$timeout', '$q', '$filter', 'ModalService', 'PolicyService', '$http', '$stateParams', '$rootScope', function ($window, $scope, $timeout, $q, $filter, ModalService, PolicyService, $http, $stateParams, $rootScope) {
            /**
             * Assigning icons for all type of files
             */
            var fileIcons = {
                doc: 'fa-file-word-o',
                docx: 'fa-file-word-o',
                docm: 'fa-file-word-o',
                pdf: 'fa-file-pdf-o',
                xlt: 'fa-file-excel-o',
                xlsx: 'fa-file-excel-o',
                xlsm: 'fa-file-excel-o',
                gif: 'fa-file-image-o',
                png: 'fa-file-image-o',
                jpeg: 'fa-file-image-o'
            };

            /**
             * List of the documents are pushed in the array
             */
            $scope.docList = ['Automatic Withdrawal Authorization Agreement', 'Construction Credit Application', 'ERM-14', 'Online Data Access Request', 'Payment Receipt', 'Payroll Report', 'Policy Information Change Form', 'Producer of Record Change', 'Other'];
            $scope.docType = 'none';
            $scope.descRequired = false;

            /**
             * Method to check whether descriptions are required or not based on the document type selection from the drop down
             */
            $scope.checkDescRequired = function () {
                var doc = angular.element(document.querySelector('#docType')).val();
                if (doc === 'Other') {
                    $scope.descRequired = true;
                } else {
                    $scope.descRequired = false;
                }
            };
            /**
             * More Link for QA and DEV server
             */
            $scope.msfHost = PolicyService.getMsfPortalHost();
            $scope.msfHost.then(function (data) {
                $scope.moreLink = data + '/Edo';
            }, function (err) {
                console.error('Error while retrieving MSF host: ', err);
            });
            /**
             * retrieve documents for the selected policy and pushing the response to finalData array
             * @param("policyNumber", "retrieved the policy number from URL")
             * @param("user_name", "Username of the portal user which will be used to update the information under created by column in policy center")
             * @returns {void} - assigning response which has been retrieved from the service call to the fullDocumentData scope object
             */
            PolicyService.getDocumentsForPolicy($stateParams.policyNumber).then(function (data) {
                var finalData = [];
                if (!window.navigator && !window.navigator.msSaveOrOpenBlob) {
                    angular.forEach(data, function (res) {
                        if (res.documentBlob != null || res.documentBlob !== undefined) {
                            var _url = covertBlobToURL(res.documentBlob);
                            res.documentURL = _url.replace('unsafe:', '');
                        }
                        finalData.push(res);
                    });
                } else {
                    finalData = data;
                }
                $scope.fullDocumentsData = finalData;
                $scope.documents = finalData;
                $scope.filteredDocuments = finalData;
                if (data.length === 0) {
                    $scope.documentsEmpty = true;
                }
            }, function () {});
            $scope.dragDropSelector = $scope.dropZoneSelector() || '.gw-file-upload-drag-area';

            /**
             * Method to remove the document when click on remove document button
             * used to check whether the document is deleted or not
             * @param ("document", "document which has been selected to remove")
             * @param ("documentId", "Selected document's public Id") 
             * @return {void} - filter out deleted documents and assign them to scope object if the response returns true boolean, if document is not getting deleted shows relevant error message to the user
             */
            $scope.removeDocument = function (document) {
                if (!document.canDelete) {
                    return;
                }
                var title = 'platform.widgets.fileupload.templates.Remove Document';
                var msg = $filter('translate')('platform.widgets.fileupload.templates.Are you sure you want to remove:', {
                    documentName: document.name
                });

                ModalService.showWarning(title, msg).result.then(function () {
                    $q.when($scope.removeFunction({ documentID: document.publicID }), function (deleted) {
                        if (deleted === true) {

                            $scope.documents = $scope.documents.filter(function (doc) {
                                return doc.workingPublicID !== document.publicID;
                            });
                        } else {
                            ModalService.showError('platform.widgets.fileupload.templates.Document Deletion May Have Failed', 'platform.widgets.fileupload.templates.Something may have gone wrong when deleting your document.');
                        }
                    }, function () {
                        ModalService.showError('platform.widgets.fileupload.templates.Unable to Delete Document', 'platform.widgets.fileupload.templates.Sorry, your document could not be deleted at this time.');
                    });
                });
            };

            $scope.getFileIcon = function (file) {
                var extension = _getFileExtension(file.docUID).toLowerCase() || '';
                return fileIcons[extension] || 'fa-file-o';
            };

            $scope.clickUpload = function () {
                angular.element('input[type=file]').trigger('click');
            };

            function _getFileExtension(name) {
                var extension = name.split('.').pop();
                return extension || '';
            }
            /**
             * Method to upload file to the Server
             * @param (files, "files which has been selected from the user")
             * get values of the all the input fields, check docType is Other and none option
             * @return {boolean} - Based on the docType it will return the error message 
             */
            $scope.uploadFile = function (files) {
                for (var i = 0; i < files.length; i++) {

                    var desc = angular.element(document.querySelector('#description')).val();
                    var doc = angular.element(document.querySelector('#docType')).val();
                    var user = angular.element(document.querySelector('#userName')).val();
                    if (doc === 'Other') {
                        if (desc === undefined || desc === '' || desc.trim() === '') {
                            ModalService.showError('platform.documentupload.DocumentUploadDirective.Description Required', 'platform.widgets.fileupload.templates.Please enter Description.');
                            return;
                        }
                        $scope.descEntered = true;
                    }
                    if (doc === 'none') {
                        ModalService.showError('platform.documentupload.DocumentUploadDirective.Error', 'platform.widgets.fileupload.templates.Please select the Document Type.');
                        return;
                    }
                    var fileData = { policyNumber: $stateParams.policyNumber, encodedFile: '', contentType: '', fileName: '', description: desc, docType: doc, userName: user };
                    var file = files[i];
                    _uploadFileToServer(file, fileData);
                }
            };
            /**
             * Main function that gets called to upload files to the server based on selected file
             * @param ("file", file which has been selected when uploading the document)
             * @param ("fileData", "Object") - Object contains policyNumber, encodedFile,contentType,filename,description,docType and username
             * @return ("accept only valid type of the selected file, if not throws error message")
             * @return ("if file size exceeds return error message")
             */
            function _uploadFileToServer(file, fileData) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {

                    var encodedFileBase64 = reader.result.substring(reader.result.indexOf(',') + 1);
                    fileData.encodedFile = encodedFileBase64;
                    fileData.fileName = file.name;
                    fileData.contentType = file.type;

                    var fileName = file.name;
                    var extension = fileName.substring(fileName.lastIndexOf('.'));
                    var extValid = ['.pdf'];
                    if (!extValid.includes(extension.toLowerCase())) {
                        ModalService.showError(fileName + ' is not a valid file type.', 'platform.widgets.fileupload.templates.Only Pdf file type is allowed (size < 5 MB).');
                        return;
                    }

                    if (file.size > 5242880) {
                        ModalService.showError('platform.widgets.fileupload.templates.size exceeds 5MB', 'platform.widgets.fileupload.templates.Please reduce the size or split the document into seperate files and upload.');
                        return;
                    }

                    PolicyService.uploadDoc(fileData).then(function (res) {

                        ModalService.showInfo('Upload Successful', fileName + ' sent to Montana State Fund.');
                    }, function () {
                        ModalService.showError('platform.documentupload.DocumentUploadDirective.Error', 'platform.widgets.fileupload.templates.An exception occurred. Please try again later, if the problem persists please contact Montana State Fund at 406-495-5000.');
                    });
                };
                reader.onerror = function (error) {
                    ModalService.showError('platform.documentupload.DocumentUploadDirective.Error', 'platform.widgets.fileupload.templates.An exception occurred. Please try again later, if the problem persists please contact Montana State Fund at 406-495-5000.');
                };
            }

            /**
             * Main function that gets called to download documents and converting blobData to URL
             * @param ("blobData", "getting document's bloData from selected file details")
             * @return ("fileURL", "creating base64 object url for the file and return")            
             */
            function covertBlobToURL(blobData) {
                var binary = DocumentUtil.decode(blobData);
                var len = binary.length;
                var view = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                    view[i] = binary.charCodeAt(i);
                }

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    // do nothing because fileUrl generation is not supported in IE
                } else {
                    // for Chrome Firefox etc
                    var file = new Blob([view], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);
                    return fileURL;
                }
            }

            /**
             * function to get document blob based on the selected FileID and open it in frontend for individual data 
             * @param ("policyNumber","policy number which has been retrieved from URL")
             * @param ("username","user name of the actual portal user to display under created by field in PC for each transaction")
             * @param ("documentblob")
             * @return {void}
             */
            $scope.openURL = function (url) {

                PolicyService.getDocumentsByFileId($stateParams.policyNumber, $rootScope.$root.authData.userData.email, url.documentBlob).then(function (data) {
                    angular.forEach(data, function (fileData) {
                        // Create Base64 Object
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            // for IE
                            var binary = DocumentUtil.decode(fileData.documentBlob);
                            var len = binary.length;
                            var view = new Uint8Array(len);
                            for (var i = 0; i < len; i++) {
                                view[i] = binary.charCodeAt(i);
                            }
                            if (url.fileName === undefined) {
                                // for IE
                                url.fileName = 'Document';
                            }
                            window.navigator.msSaveOrOpenBlob(new Blob([view], { type: 'application/pdf' }), url.fileName);
                            // Entering document click information in EUTS for analytics purpose
                            PolicyService.callEUTS('Policy Details', url.documentBlob + url.fileName, $stateParams.policyNumber, 'Download Selected Documents');
                        } else {
                            // for Chrome Firefox etc
                            if (fileData.documentBlob != null && fileData.documentBlob != undefined) {
                                var _url = covertBlobToURL(fileData.documentBlob);
                                $window.open(_url);
                                // Entering document click information in EUTS for analytics purpose
                                PolicyService.callEUTS('Policy Details', url.documentBlob + url.fileName, $stateParams.policyNumber, 'Download Selected Documents');
                            }
                        }
                    });
                }, function () {});
            };

            $scope.filteredDocuments = $scope.documents;

            /**
             * watch collection to listen the documents to verify the new value and old value
             * pass the documents through event listener if new value is not equal to old value
             */
            $scope.$watchCollection('documents', function (newValue, oldValue) {

                if (newValue && newValue !== oldValue) {
                    $scope.filteredDocuments = $scope.documents;
                    $scope.$emit('documentsUpdated', $scope.documents);
                }
            });

            $scope.$watch('dataTemplate', function () {
                $scope.metadataTemplate = $scope.documentMetadataTemplate;
            });
            $scope.$watch('documentQuery', function () {
                $scope.applyFilter();
            });

            $scope.isRecentlyAdded = function (id) {
                return _.contains($scope.recentlyAddedIDs, id);
            };

            $scope.$on('fileuploaddone', function (e, data) {
                $scope.recentlyAddedIDs.push(data.result.result.publicID);
            });

            $scope.$on('fileuploadstart', function () {
                $scope.recentlyAddedIDs = [];
            });

            $scope.applyFilter = function () {
                if ($scope.documentQuery !== undefined && $scope.documentQuery != '') {
                    $scope.filteredDocuments = $filter('filter')($scope.documents, {
                        fileName: $scope.documentQuery
                    });
                } else {
                    $scope.filteredDocuments = $scope.fullDocumentsData;
                }
            };

            $scope.closeAlert = function (index) {
                $scope.alerts.splice(index, 1);
            };

            $scope.allDocs = 0;
            $scope.pageSize = 20;
            $scope.queryOptions = {
                offsetStart: 0,
                offsetEnd: $scope.pageSize - 1
            };

            /**
             * Method to get documents for current user for particular policy
             * @param ("policyNumber", "policy number which has been retrieved from the URL")
             * @param ("email","email of the actual portal user")
             * @return{DocumentDTO, "Returns documents related to a given policy"}
             */
            function getDocsCurrentUser() {
                if ($scope.allDocs === 0) {
                    $scope.allDocs = PolicyService.getDocumentsForPolicy($stateParams.policyNumber, $rootScope.$root.authData.userData.email);
                }
                return $scope.allDocs;
            }

            /**
             * Main function that gets called to retrieve the documents for current user
             * filter finalData array order by delivery date and get the data based on the offset value
             * @returns {items, maxNumberOfResults} - returns the document details for the current user and length of the document
             */
            function updateDocumentData() {

                return getDocsCurrentUser().then(function (data) {

                    var finalData = [];
                    angular.forEach(data, function (res) {
                        if (res.documentBlob != null || res.documentBlob !== undefined) {
                            var _url = covertBlobToURL(res.documentBlob);
                            res.documentURL = _url;
                        }
                        finalData.push(res);
                    });

                    $scope.filteredJobs = $filter('orderBy')(finalData, 'deliveryDate').reverse();

                    $scope.allJobData = $scope.filteredJobs.slice($scope.queryOptions.offsetStart, $scope.queryOptions.offsetEnd + 1);

                    return {
                        'items': $scope.allJobData,
                        'maxNumberOfResults': finalData.length
                    };
                }, function () {
                    $scope.jobsLoading = false;
                });
            }

            $scope.tableTitle = ' ';
            $scope.loadingComplete = true;
            var _getLoadByOffset = _.memoize(function () {
                return function (offsetStart, offsetEnd) {
                    $scope.queryOptions.offsetStart = offsetStart;
                    $scope.queryOptions.offsetEnd = offsetEnd;
                    return updateDocumentData();
                };
            });

            $scope.getLoadByOffset = function () {

                return _getLoadByOffset();
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/fileupload/FileUploadViewer.js
// module id = 1961
// module chunks = 0